import React from 'react';

import { OpenCloseMarker } from '@/app/components/OpenCloseMarker';
import { HighlightableString } from '@/app/log-viewer/highlighting/HighlightableString';
import {
  HighlightableStringExpandableContainer,
  isExpandedState,
} from '@/app/log-viewer/highlighting/HighlightableStringExpandableContainer';
import { HighlightableStringView } from '@/app/log-viewer/highlighting/HighlightableStringView';

export interface KeyValuePairsDataModel extends HighlightableStringExpandableContainer {
  title: HighlightableString;
  entries: HighlightableString[];
}

export type NetworkRequestKeyValuePairDetailsProps = {
  dataModel: KeyValuePairsDataModel;
  onOpenToggle: () => void;
};

export class NetworkRequestKeyValuePairDetails extends React.Component<NetworkRequestKeyValuePairDetailsProps> {
  render() {
    const data = this.props.dataModel;
    const isOpen = isExpandedState(data.expandingState);

    return (
      <div>
        <div className="details-header" onClick={this.props.onOpenToggle}>
          <OpenCloseMarker open={isOpen} />
          &nbsp;
          <HighlightableStringView string={data.title} />
        </div>

        {isOpen ? (
          <div>
            {data.entries.map((kv, index) => {
              return (
                <div key={index}>
                  <HighlightableStringView string={kv} />
                </div>
              );
            })}
          </div>
        ) : null}
      </div>
    );
  }
}
